import React from 'react'
import PropTypes from 'prop-types'

import { TabNavigation } from '../../TabNavigation'
import { useDropdownContext } from '../DropdownContext'

const TextOption = ({
  children,
  onClick = () => {},
  isActive = false,
  onOptionClick: customOnOptionClick,
  shouldCloseOnClick = true,
  isDisabled = false,
  ...rest
}) => {
  const { toggle } = useDropdownContext()

  const onOptionClick = (event) => {
    if (isDisabled) return

    if (customOnOptionClick) {
      const result = customOnOptionClick(event, {
        toggle,
        isActive,
        isDisabled,
      })
      if (result === false) return
    } else {
      onClick(event)
    }

    if (shouldCloseOnClick) {
      toggle()
    }
  }

  return (
    <TabNavigation
      as="button"
      size="m"
      className="text-option"
      role="menuitem"
      aria-selected={isActive}
      data-active={isActive}
      data-disabled={isDisabled}
      isDisabled={isDisabled}
      onClick={onOptionClick}
      onEnterPress={onOptionClick}
      {...rest}
    >
      {children}
    </TabNavigation>
  )
}

TextOption.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onOptionClick: PropTypes.func,
  shouldCloseOnClick: PropTypes.bool,
}

export default TextOption
